import React, { useEffect, useState, useRef, lazy } from 'react';
import { TestimonialCard } from './TestimonialCard';
import { CTAButton } from './CTAButton';
import { StickyCTA } from './StickyCTA';
import { EyeIcon, CheckCircle, AlertCircle, ImageIcon } from 'lucide-react';
export const Advertorial = () => {
  const [isScrolledPastFirstTwoSections, setIsScrolledPastFirstTwoSections] = useState(false);
  const [isAtTopSection, setIsAtTopSection] = useState(true);
  const [userCity, setUserCity] = useState('New York');
  const firstTwoSectionsRef = useRef(null);
  // Fetch user location data
  useEffect(() => {
    const fetchUserLocation = async () => {
      try {
        const response = await fetch('https://ipinfo.io/json');
        if (response.ok) {
          const data = await response.json();
          if (data.city && data.city.trim() !== '') {
            setUserCity(data.city);
            console.log(`User location detected: ${data.city}`);
          }
        }
      } catch (error) {
        console.error('Error fetching location data:', error);
        // Keep default "New York" if there's an error
      }
    };
    fetchUserLocation();
  }, []);
  useEffect(() => {
    // Set initial states
    setIsScrolledPastFirstTwoSections(false);
    setIsAtTopSection(true);
    const scrollOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -90% 0px' // Consider element as "passed" when it's 90% above the viewport
    };
    const topSectionOptions = {
      threshold: 0.3,
      rootMargin: '-100px 0px 0px 0px' // Consider top section visible when at least 30% is visible
    };
    const scrollObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        // When the section is no longer intersecting (scrolled past it)
        if (!entry.isIntersecting) {
          setIsScrolledPastFirstTwoSections(true);
        } else {
          setIsScrolledPastFirstTwoSections(false);
        }
      });
    }, scrollOptions);
    const topSectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        // When the top section is visible
        if (entry.isIntersecting) {
          setIsAtTopSection(true);
        } else {
          setIsAtTopSection(false);
        }
      });
    }, topSectionOptions);
    // Small delay to ensure DOM is fully rendered
    setTimeout(() => {
      if (firstTwoSectionsRef.current) {
        scrollObserver.observe(firstTwoSectionsRef.current);
        topSectionObserver.observe(firstTwoSectionsRef.current);
      }
    }, 100);
    return () => {
      if (firstTwoSectionsRef.current) {
        scrollObserver.unobserve(firstTwoSectionsRef.current);
        topSectionObserver.unobserve(firstTwoSectionsRef.current);
      }
    };
  }, []);
  // Log the state for debugging
  useEffect(() => {
    console.log('Scrolled past first two sections:', isScrolledPastFirstTwoSections, 'At top section:', isAtTopSection);
  }, [isScrolledPastFirstTwoSections, isAtTopSection]);
  return <div className="w-full bg-white pb-20 md:pb-24" data-id="element-7">
      {/* Top Header Bar */}
      <div className="w-full bg-gray-900 text-white" data-id="element-8">
        <div className="container mx-auto px-4 py-2 flex flex-col sm:flex-row justify-between items-center gap-2" data-id="element-9">
          <div className="flex items-center" data-id="element-10">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-2" data-id="element-11">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="white" data-id="element-12" />
            </svg>
            <span className="font-semibold tracking-wider text-sm sm:text-base" data-id="element-13">
              WOMEN'S HEALTH
            </span>
          </div>
          <div className="flex items-center" data-id="element-14">
            <div className="w-5 h-5 mr-2 rounded-full overflow-hidden flex-shrink-0" data-id="element-15">
              <svg viewBox="0 0 512 512" className="w-full h-full" data-id="element-16">
                <path fill="#f0f0f0" d="M0 85.331h512v341.337H0z" data-id="element-17" />
                <path fill="#d80027" d="M0 85.331h512v42.663H0zm0 85.337h512v42.663H0zm0 85.337h512v42.663H0zm0 85.337h512v42.663H0z" data-id="element-18" />
                <path fill="#2e52b2" d="M0 85.331h256v183.797H0z" data-id="element-19" />
                <path fill="#f0f0f0" d="M99.822 160.624L95.699 173.308H82.363L93.113 181.143L89.021 193.826L99.822 186.034L110.624 193.826L106.532 181.143L117.306 173.308H103.97z" data-id="element-20" />
                <path fill="#f0f0f0" d="M103.622 219.081l-3.284 10.134h-10.638l8.609 6.333-3.284 10.134 8.598-6.348 8.598 6.348-3.284-10.134 8.609-6.333h-10.638zM167.737 160.624l-4.123 12.684h-13.336l10.75 7.835-4.092 12.683 10.801-7.792 10.802 7.792-4.092-12.683 10.774-7.835h-13.336zM167.737 219.081l-3.284 10.134h-10.638l8.609 6.333-3.284 10.134 8.598-6.348 8.598 6.348-3.284-10.134 8.609-6.333h-10.638zM31.908 160.624l-4.123 12.684H14.449l10.75 7.835-4.092 12.683 10.801-7.792 10.802 7.792-4.092-12.683 10.774-7.835H36.031zM31.908 219.081l-3.284 10.134H17.986l8.609 6.333-3.284 10.134 8.598-6.348 8.598 6.348-3.284-10.134 8.609-6.333H35.192z" data-id="element-21" />
              </svg>
            </div>
            <span className="text-xs sm:text-sm" data-id="element-22">Trending in the US</span>
          </div>
        </div>
      </div>
      {/* Header */}
      <header className="w-full border-b border-gray-200" data-id="element-23">
        <div className="container mx-auto px-4 py-3" data-id="element-24">
          <p className="text-xs font-semibold text-gray-500 tracking-wider" data-id="element-25">
            WOMEN'S HEALTH | Advertorial
          </p>
        </div>
      </header>
      {/* Notification Banner */}
      <div className="w-full bg-amber-50 border border-amber-200" data-id="element-26">
        <div className="container mx-auto px-4 py-3 flex items-start sm:items-center justify-center text-center" data-id="element-27">
          <AlertCircle className="text-red-500 mr-2 flex-shrink-0 mt-0.5 sm:mt-0" size={20} data-id="element-28" />
          <p className="font-bold text-xs sm:text-sm md:text-base text-left sm:text-center" data-id="element-29">
            UPDATE: Elivara Compression Leggings Are Selling Out FAST! Grab
            Yours NOW to get up to 40% OFF + Fast FREE Shipping Across the US
          </p>
        </div>
      </div>
      {/* Main Content */}
      <div className="container mx-auto px-4" data-id="element-30">
        <div className="flex flex-col lg:flex-row lg:justify-center lg:gap-8" data-id="element-31">
          {/* Main Content */}
          <main className="w-full max-w-3xl mx-auto lg:mx-0" data-id="element-32">
            <div className="py-4 sm:py-6 px-0" data-id="element-33">
              {/* Headline */}
              <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-3 sm:mb-4 leading-tight" data-id="element-34">
                {userCity} Doctors Reveal: Lipedema Could Be the Real Reason
                Your Arms Never Got Smaller — No Matter How Much You Dieted
              </h1>
              {/* Subheadline */}
              <p className="text-base sm:text-lg md:text-xl text-gray-600 mb-4 sm:mb-6 leading-relaxed" data-id="element-35">
                Up to 17 million women in the US suffer from Lipedema — and a
                new compression breakthrough is helping them finally find relief
                without looking or feeling medical.
              </p>
              {/* Author and Date */}
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between border-b border-gray-200 pb-3 sm:pb-4 mb-4 sm:mb-6 gap-2" data-id="element-36">
                <div className="flex items-center" data-id="element-37">
                  <p className="text-xs sm:text-sm text-gray-700" data-id="element-38">
                    By Sarah Mitchell, Women's Health | April 29, 2025
                  </p>
                </div>
                <div className="flex items-center text-xs sm:text-sm text-gray-500" data-id="element-39">
                  <EyeIcon size={16} className="mr-1" data-id="element-40" />
                  <span data-id="element-41">247,891</span>
                </div>
              </div>
              {/* Featured Image */}
              <div className="mb-6 sm:mb-8 rounded-lg overflow-hidden" data-id="element-42">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rfQ9cr7C1vcWQVA1xL6MwD/ChatGPT_Image_22_%CE%9D%CE%BF%CE%B5_2025%2C_06_23_31_%CE%BC.%CE%BC..png" alt="Image of a woman looking frustrated while measuring her upper arms, showing visible disproportionate size compared to her lower body" className="w-full h-auto" data-id="element-43" />
              </div>
              {/* Personal Story Section */}
              <div className="mb-8 sm:mb-10" data-id="element-44">
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-45">
                  I'll never forget the day my doctor looked at me across her
                  desk and said, "You just need to lose weight."
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-46">
                  I wanted to scream. I wanted to cry. Instead, I just nodded
                  and left her office feeling more defeated than ever.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-47">
                  Because here's the thing: I HAD been losing weight. For two
                  years, I'd been eating clean, tracking every calorie, going to
                  the gym five days a week. My waist got smaller. My face
                  slimmed down. My legs got toned. But my arms? They stayed
                  exactly the same size. Swollen. Painful. Completely out of
                  proportion with the rest of my body.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-48">
                  I started wearing long sleeves year-round. Even in the summer.
                  Even at the beach. I couldn't stand seeing my arms next to
                  other women's arms. I felt broken. Like my body was betraying
                  me no matter how hard I tried.
                </p>
                <p className="mb-3 sm:mb-4 font-semibold text-sm sm:text-base" data-id="element-49">
                  Sound familiar?
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-50">
                  If you've experienced this — if you've ever felt like your
                  arms simply refuse to respond to diet and exercise while the
                  rest of your body changes — you need to keep reading. Because
                  what I discovered changed everything.
                </p>
              </div>
              {/* The Hidden Condition Section - This marks the end of the first two sections */}
              <div className="mb-8 sm:mb-10" ref={firstTwoSectionsRef} data-id="element-51">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-3 sm:mb-4 leading-tight" data-id="element-52">
                  The Hidden Condition Affecting Millions of Women (And Most
                  Don't Even Know It)
                </h2>
                {/* Medical Condition Image */}
                <div className="mb-4 sm:mb-6 rounded-lg overflow-hidden" data-id="element-53">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/m9g7umpbQUcEETPScspXRj/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_23_%CF%80.%CE%BC..png" alt="Medical illustration showing the difference between normal fat tissue and lipedema fat tissue in arms, highlighting the fluid buildup and inflammation" className="w-full h-auto" data-id="element-54" />
                </div>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-55">
                  It turns out, I wasn't broken. I wasn't lazy. And I wasn't
                  eating "too much."
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-56">
                  I had a legitimate medical condition called lipedema — and
                  according to the National Institutes of Health, it affects an
                  estimated 11% of women in the United States alone. That's
                  roughly 17 million women walking around thinking they just
                  have "stubborn fat" or "bad genetics," when in reality, they
                  have a chronic condition that diet and exercise simply cannot
                  fix.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-57">
                  Here's what lipedema actually is:
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-58">
                  Lipedema is a disorder of fatty tissue that causes fat to
                  accumulate abnormally in the arms (and sometimes legs),
                  creating a disproportionate appearance. The fat cells in
                  lipedema are different from normal fat cells. They're
                  dysfunctional, inflamed, and they trap fluid in the tissue.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-59">
                  The telltale signs include:
                </p>
                <ul className="list-disc pl-5 sm:pl-6 mb-3 sm:mb-4 space-y-2 text-sm sm:text-base" data-id="element-60">
                  <li className="leading-relaxed" data-id="element-61">
                    Disproportionately large arms compared to your lower body
                    (often described as "column-like" or "bat wing" appearance)
                  </li>
                  <li className="leading-relaxed" data-id="element-62">
                    Fat that doesn't respond to diet or exercise
                  </li>
                  <li className="leading-relaxed" data-id="element-63">
                    Arms that are painful, tender to touch, or feel heavy
                  </li>
                  <li className="leading-relaxed" data-id="element-64">Easy bruising on the arms</li>
                  <li className="leading-relaxed" data-id="element-65">
                    Symmetrical fat distribution (both arms affected equally)
                  </li>
                  <li className="leading-relaxed" data-id="element-66">
                    Swelling that worsens as the day goes on
                  </li>
                  <li className="leading-relaxed" data-id="element-67">
                    Fat deposits around the triceps, back of arms, and elbows
                  </li>
                </ul>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-68">
                  But here's the most frustrating part: Most doctors miss it
                  completely.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-69">
                  They look at overweight women and immediately jump to obesity.
                  They prescribe weight loss without understanding that lipedema
                  fat is fundamentally different from regular adipose tissue.
                  It's why we can starve ourselves and exercise until we're
                  exhausted, and our arms stay exactly the same size.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-70">
                  This isn't about willpower. It's about biology.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-71">
                  And for years, I thought I was the only one suffering. I
                  thought I was alone. But once I finally got my diagnosis, I
                  realized there were millions of women out there experiencing
                  the exact same thing — the shame, the frustration, the feeling
                  of being trapped in a body that wouldn't cooperate.
                </p>
              </div>
              {/* All remaining sections with responsive text and spacing */}
              <div className="mb-8 sm:mb-10" data-id="element-72">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-3 sm:mb-4 leading-tight" data-id="element-73">
                  Why Everything You've Tried Hasn't Worked
                </h2>
                <div className="mb-4 sm:mb-6 rounded-lg overflow-hidden" data-id="element-74">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8b6k5hJxJ4gJ6p6Xm27yos/ChatGPT_Image_22_%CE%9D%CE%BF%CE%B5_2025%2C_06_28_39_%CE%BC.%CE%BC..png" alt="Image showing traditional medical-grade compression arm sleeves next to a frustrated woman trying to put them on, illustrating how uncomfortable and medical they look" className="w-full h-auto" data-id="element-75" />
                </div>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-76">
                  Once I understood what lipedema was, the next question became
                  obvious: What do I do about it?
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-77">
                  My doctor recommended compression sleeves. You know, those
                  thick, medical-grade sleeves that are impossible to put on,
                  cut off your circulation, and look like something you'd wear
                  after surgery.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-78">
                  I tried them. And honestly? They made things worse.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-79">
                  Here's why standard compression doesn't work for lipedema:
                </p>
                <div className="bg-red-50 p-4 sm:p-6 rounded-md mb-4 sm:mb-6" data-id="element-80">
                  <p className="font-semibold mb-2 text-sm sm:text-base" data-id="element-81">
                    The One-Size-Fits-All Problem:
                  </p>
                  <p className="mb-3 text-sm sm:text-base leading-relaxed" data-id="element-82">
                    Most compression garments use uniform pressure from top to
                    bottom. They squeeze your arms with the same intensity
                    everywhere. But your arms aren't uniform — they have natural
                    curves, different tissue densities, and varying fluid
                    accumulation zones.
                  </p>
                  <p className="font-semibold mb-2 text-sm sm:text-base" data-id="element-83">
                    The Tourniquet Effect:
                  </p>
                  <p className="mb-3 text-sm sm:text-base leading-relaxed" data-id="element-84">
                    When compression is too tight or applied incorrectly, it
                    actually creates a tourniquet effect that traps fluid rather
                    than moving it. You end up with even more swelling at the
                    compression line, making your arms look and feel worse.
                  </p>
                  <p className="font-semibold mb-2 text-sm sm:text-base" data-id="element-85">
                    They're Uncomfortable and Obvious:
                  </p>
                  <p className="mb-3 text-sm sm:text-base leading-relaxed" data-id="element-86">
                    Let's be real — traditional compression sleeves are thick,
                    hot, uncomfortable, and scream "medical device." You can't
                    wear them under normal clothes. You definitely can't wear
                    them with a tank top or sleeveless dress. So women just...
                    don't wear them. And if you're not wearing the solution,
                    it's not solving anything.
                  </p>
                  <p className="font-semibold mb-2 text-sm sm:text-base" data-id="element-87">
                    They Don't Address the Root Cause:
                  </p>
                  <p className="mb-0 text-sm sm:text-base leading-relaxed" data-id="element-88">
                    Lipedema happens because your lymphatic system isn't
                    draining fluid properly from the affected tissue. The fluid
                    gets trapped, inflammation increases, and the tissue becomes
                    more damaged over time. Standard compression just squeezes
                    everything equally without specifically targeting lymphatic
                    flow.
                  </p>
                </div>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-89">
                  I felt stuck. The only "solution" available was something I
                  couldn't stand to wear, that didn't even work that well, and
                  that made me feel even more self-conscious about my arms.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-90">
                  That's when I realized the problem wasn't compression itself —
                  it was the wrong kind of compression.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-91">
                  There had to be something better.
                </p>
              </div>
              {/* The Breakthrough Section */}
              <div className="mb-8 sm:mb-10" data-id="element-92">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-3 sm:mb-4 leading-tight" data-id="element-93">
                  The Breakthrough That Changed Everything
                </h2>
                <div className="mb-4 sm:mb-6 rounded-lg overflow-hidden" data-id="element-94">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nxS34pVqFUW3fpaNNH7eab/ChatGPT_Image_22_%CE%9D%CE%BF%CE%B5_2025%2C_06_31_47_%CE%BC.%CE%BC..png" alt="Image of Elivara Arm Sculpt compression sleeves showing the stylish design with FlowMapping™ technology zones highlighted with glowing orange lines" className="w-full h-auto" data-id="element-95" />
                </div>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-96">
                  That's when I discovered Elivara — and specifically, their
                  revolutionary FlowMapping™ Compression technology.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-97">
                  When I first heard about it, I was skeptical. Another
                  compression product? Really?
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-98">
                  But Elivara is fundamentally different from anything else on
                  the market. And the difference comes down to one key insight:
                  Your body has natural pathways for lymphatic drainage, and
                  compression needs to follow those pathways — not fight against
                  them.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-99">
                  Here's how FlowMapping™ actually works:
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-100">
                  Instead of applying uniform pressure across your entire arm
                  (like old-school compression sleeves), Elivara uses graduated
                  pressure zones that are specifically designed to match your
                  body's lymphatic system.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-101">
                  Think of it like this: Your lymphatic fluid needs to move in a
                  specific direction — up and out of your arms, toward the lymph
                  nodes in your upper arm and armpit area. FlowMapping™ creates
                  a gentle pressure gradient that guides trapped fluid along
                  your natural drainage pathways, accelerating lymphatic flow
                  without creating that uncomfortable tourniquet effect.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-102">
                  The pressure is strongest at your wrists (where fluid tends to
                  pool the most) and gradually decreases as it moves up your
                  arm. This gradient naturally encourages fluid to move upward
                  and drain properly, rather than getting stuck.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-103">
                  But here's what really sets Elivara apart: They designed these
                  specifically for women with lipedema.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-104">
                  Most compression garments are made for generic swelling or
                  medical conditions that affect the elderly. Elivara spent
                  years studying lipedema — understanding the unique fat
                  distribution patterns in arms, the specific areas where fluid
                  accumulates, the tender zones where pressure needs to be
                  gentler.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-105">
                  The result? Arm sleeves that deliver therapeutic-level relief
                  while looking and feeling like regular activewear.
                </p>
                <p className="mb-3 sm:mb-4 font-semibold text-sm sm:text-base" data-id="element-106">
                  I'm not exaggerating when I say these changed my life.
                </p>
              </div>
              {/* New Section: Visual Explanation of FlowMapping™ Technology */}
              <div className="mb-8 sm:mb-10" data-id="element-107">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-3 sm:mb-4 leading-tight" data-id="element-108">
                  See the FlowMapping™ Difference
                </h2>
                <div className="mb-4 sm:mb-6 rounded-lg overflow-hidden bg-blue-50 p-3 sm:p-4" data-id="element-109">
                  <img src="https://i.imgur.com/V8GvFql.gif" alt="Animated demonstration of FlowMapping™ technology showing how directional compression guides fluid drainage in lipedema-affected arms" className="w-full h-auto mx-auto" data-id="element-110" />
                </div>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-111">
                  This visual perfectly captures what makes FlowMapping™
                  technology so revolutionary. On the left, you can see what
                  happens in lipedema-affected arms: fluid builds up (shown in
                  red), creating painful inflammation and swelling that doesn't
                  respond to diet or exercise.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-112">
                  On the right, you see how Elivara's patented FlowMapping™
                  technology works. The strategically placed compression zones
                  (shown as green chevrons) create directional pressure that
                  guides trapped fluid along your natural lymphatic pathways.
                  This helps your body drain the fluid properly, reducing
                  swelling, pain, and that heavy feeling that comes with
                  lipedema.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-113">
                  The chevron patterns aren't just for show—they represent the
                  actual directional support built into every pair of Elivara
                  arm sleeves. This is why women report feeling immediate relief
                  when they put them on. The technology is actively working with
                  your body's natural systems, not against them.
                </p>
              </div>
              {/* What It Actually Feels Like Section */}
              <div className="mb-8 sm:mb-10" data-id="element-114">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-3 sm:mb-4 leading-tight" data-id="element-115">
                  What It Actually Feels Like to Wear Them
                </h2>
                <div className="mb-4 sm:mb-6 rounded-lg overflow-hidden" data-id="element-116">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qqAcxpEZuA9mM1NC4cVZrb/ChatGPT_Image_22_%CE%9D%CE%BF%CE%B5_2025%2C_06_42_26_%CE%BC.%CE%BC..png" alt="Image of a smiling woman wearing Elivara arm sleeves while doing everyday activities, showing how they look like normal sleeves but provide therapeutic benefits" className="w-full h-auto" data-id="element-117" />
                </div>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-118">
                  The first time I put on my Elivara arm sleeves, I noticed the
                  difference immediately.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-119">
                  They weren't difficult to get on like traditional compression
                  sleeves. They felt like... comfortable activewear. Soft,
                  breathable sleeves that I'd actually want to wear.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-120">
                  But within an hour, I felt something I hadn't felt in years:
                  my arms felt lighter.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-121">
                  That heavy, swollen feeling I'd gotten so used to? It started
                  to ease. The constant aching? It dulled. By the end of the day
                  — when my arms were usually at their absolute worst — they
                  felt better than they normally did first thing in the morning.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-122">
                  I started wearing them every day. And the changes kept coming:
                </p>
                <div className="space-y-3 sm:space-y-4 mb-4 sm:mb-6" data-id="element-123">
                  <div className="flex items-start" data-id="element-124">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={18} data-id="element-125" />
                    <p className="text-sm sm:text-base leading-relaxed" data-id="element-126">
                      <span className="font-semibold" data-id="element-127">
                        My arms looked slimmer.
                      </span>{' '}
                      The constant swelling that made my arms appear even larger
                      started to reduce. I could see more definition. More
                      shape. Less of that "column" appearance.
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-128">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={18} data-id="element-129" />
                    <p className="text-sm sm:text-base leading-relaxed" data-id="element-130">
                      <span className="font-semibold" data-id="element-131">
                        The pain decreased significantly.
                      </span>{' '}
                      Lipedema arms are often tender and painful to the touch.
                      The FlowMapping™ compression reduced inflammation and
                      fluid buildup, which meant less pain, less tenderness, and
                      fewer random bruises.
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-132">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={18} data-id="element-133" />
                    <p className="text-sm sm:text-base leading-relaxed" data-id="element-134">
                      <span className="font-semibold" data-id="element-135">I had more energy.</span>{' '}
                      When you're carrying around excess fluid in your arms all
                      day, it's exhausting. Once that fluid started draining
                      properly, I genuinely had more energy to get through my
                      day.
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-136">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={18} data-id="element-137" />
                    <p className="text-sm sm:text-base leading-relaxed" data-id="element-138">
                      <span className="font-semibold" data-id="element-139">I stopped hiding.</span>{' '}
                      This was the big one. I started wearing sleeveless dresses
                      again. I went to the beach in a tank top. I stopped
                      obsessing over finding the longest sleeves possible to
                      cover my arms. Because for the first time in years, I
                      didn't feel like I had to.
                    </p>
                  </div>
                </div>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-140">
                  Elivara gave me something I thought I'd lost forever: the
                  freedom to just live normally.
                </p>
              </div>
              {/* Testimonials Section */}
              <div className="mb-8 sm:mb-10" data-id="element-141">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-4 sm:mb-6 leading-tight" data-id="element-142">
                  Real Women, Real Results
                </h2>
                <div className="mb-4 sm:mb-6 rounded-lg overflow-hidden" data-id="element-143">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1JWp9ABMLF3gBKwCoyvPzt/4.png" alt="Before and after comparison showing 'Without Support' vs 'With Elivara' illustrating the visible reduction in arm swelling and improved arm shape" className="w-full h-auto" data-id="element-144" />
                </div>
                <p className="mb-4 sm:mb-6 text-sm sm:text-base leading-relaxed" data-id="element-145">
                  I'm not the only one who's experienced this transformation.
                  Thousands of women with lipedema have discovered Elivara, and
                  the testimonials are genuinely moving:
                </p>
                <div className="space-y-4 sm:space-y-6 mb-4 sm:mb-6" data-id="element-146">
                  <TestimonialCard quote="For years I thought my arms were just stubborn fat. Then I learned it was lipedema. These sleeves gave me back my confidence." author="Michelle T." age="45" location="Denver, CO" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/3y7To7DiABw2UivqWYkvYv/images_%2842%29.jpg" data-id="element-147" />
                  <TestimonialCard quote="I can't believe I spent so many years thinking something was wrong with ME. Once I understood it was lipedema and found Elivara, everything changed. These don't look medical at all — they just look like nice arm sleeves. But the relief they provide is incredible." author="Sarah W." age="39" location="Seattle, WA" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/1ZzQbxP1337U3TnJrDfMSW/istockphoto-1290775513-612x612.jpg" data-id="element-148" />
                  <TestimonialCard quote="I cried when I put these on. Not because they hurt — because they actually felt GOOD." author="Jessica R." age="42" location="Portland, OR" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/jA5TbK1HAopveddK7FXfLL/mockup-pretty-curvy-latin-woman-600nw-2460705183.webp" data-id="element-149" />
                  <TestimonialCard quote="I've tried every compression sleeve on the market. They all cut into my arms, left marks, and were so uncomfortable I could barely make it through the day. Elivara is completely different. They're soft, they breathe, and they actually reduce my swelling without that horrible tourniquet feeling. I wear them literally every single day now." author="Melissa J." age="47" location="Miami, FL" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/8hW674k71ojpsCMkVCgv6R/Screenshot_2025-09-30_at_00.02.40.png" data-id="element-150" />
                  <TestimonialCard quote="My arms are lighter, my pain is less, and I finally feel like myself again." author="Amanda K." age="38" location="Austin, TX" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/hq1HCFwLGMXQeBfL6EFNpY/istockphoto-1180524344-612x612.jpg" data-id="element-151" />
                  <TestimonialCard quote="For years I thought I was just destined to have huge, painful arms. My doctor kept telling me to lose weight, but no matter what I did, my arms stayed the same. Finding out I had lipedema was validating, but I still didn't know what to do about it. Elivara changed that. The FlowMapping™ technology actually works. My arms feel lighter, they look better, and most importantly — I'm not in constant pain anymore." author="Rebecca L." age="44" location="Nashville, TN" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/vLXJxevCdw389ZygZwFFUQ/Screenshot_2025-09-30_at_00.02.43.png" data-id="element-152" />
                  <TestimonialCard quote="I can travel again without my arms swelling like balloons." author="Linda M." age="51" location="Chicago, IL" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/nJ43KvrRnAa3kWNkkTfCWz/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_12_12_37_%CF%80.%CE%BC..png" data-id="element-153" />
                  <TestimonialCard quote="Before Elivara, any time I flew or took a long car ride, my arms would swell so badly I could barely lift them. Now I wear my Elivara sleeves whenever I travel, and the difference is night and day. I just got back from a trip to Europe — something I never would have attempted before — and my arms felt better than they have in years." author="Patricia D." age="55" location="Boston, MA" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/eb9DbMXxnEv4xRdj6M31AN/Beth_-_living_with_lipedema.webp" data-id="element-154" />
                </div>
              </div>
              {/* Why Elivara Works Section */}
              <div className="mb-8 sm:mb-10" data-id="element-155">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-3 sm:mb-4 leading-tight" data-id="element-156">
                  Why Elivara Works When Everything Else Failed
                </h2>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-157">
                  You might be wondering: What makes Elivara so different from
                  all the other compression products out there?
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-158">
                  It comes down to three key factors:
                </p>
                <div className="mb-4 sm:mb-6 rounded-lg overflow-hidden" data-id="element-159">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jeuUy9w913Hw85tvkmZ7vH/%CE%91%CE%BD%CF%89%CE%BD%CF%85%CE%BC%CE%BF_%CF%83%CF%87%CE%B5%CE%B4%CE%B9%CE%BF_%2847%29.png" alt="Illustration comparing Traditional Compression with uniform pressure versus FlowMapping™ Technology with directional support following the lymphatic system pathways" className="w-full h-auto" data-id="element-160" />
                </div>
                <div className="space-y-4 sm:space-y-6 mb-4 sm:mb-6" data-id="element-161">
                  <div className="bg-blue-50 p-4 sm:p-6 rounded-lg" data-id="element-162">
                    <h3 className="font-bold text-base sm:text-lg mb-2" data-id="element-163">
                      1. Lipedema-Specific Design
                    </h3>
                    <p className="text-sm sm:text-base leading-relaxed" data-id="element-164">
                      Elivara isn't generic compression. Every single design
                      element is based on research into lipedema — how the fat
                      distributes in arms, where fluid accumulates, which areas
                      are most tender, and how the lymphatic system needs to
                      drain. This isn't a one-size-fits-all solution adapted for
                      lipedema; it's built from the ground up specifically for
                      women with this condition.
                    </p>
                  </div>
                  <div className="bg-blue-50 p-4 sm:p-6 rounded-lg" data-id="element-165">
                    <h3 className="font-bold text-base sm:text-lg mb-2" data-id="element-166">
                      2. FlowMapping™ Technology
                    </h3>
                    <p className="text-sm sm:text-base leading-relaxed" data-id="element-167">
                      The graduated pressure system doesn't just squeeze your
                      arms randomly. It creates a precise pressure gradient that
                      follows your body's natural lymphatic pathways, gently
                      guiding trapped fluid where it needs to go. It's the
                      difference between squeezing a water balloon (which just
                      moves the water around without releasing it) and creating
                      a channel that allows the water to drain properly.
                    </p>
                  </div>
                  <div className="bg-blue-50 p-4 sm:p-6 rounded-lg" data-id="element-168">
                    <h3 className="font-bold text-base sm:text-lg mb-2" data-id="element-169">
                      3. Lifestyle-First Approach
                    </h3>
                    <p className="text-sm sm:text-base leading-relaxed" data-id="element-170">
                      Here's what really sets Elivara apart: they understand
                      that a solution only works if you actually use it. That's
                      why these arm sleeves look stylish, feel comfortable, and
                      work with your life instead of against it. You can wear
                      them to work, to the gym, running errands, or out to
                      dinner. They don't look medical. They don't scream "I have
                      a condition." They just look like sleek arm wear — that
                      happen to provide therapeutic-level relief.
                    </p>
                  </div>
                </div>
              </div>
              {/* First CTA Section */}
              <div className="mb-8 sm:mb-10 bg-gray-100 p-4 sm:p-6 rounded-lg" data-id="element-171">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-3 sm:mb-4 leading-tight" data-id="element-172">
                  This Is Your Chance to Finally Get Relief
                </h2>
                <div className="mb-4 sm:mb-6 bg-white rounded-lg overflow-hidden" data-id="element-173">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9Pz9Z2VWWNvkgsJmDgnm1u/%CE%91%CE%BD%CF%89%CE%BD%CF%85%CE%BC%CE%BF_%CF%83%CF%87%CE%B5%CE%B4%CE%B9%CE%BF_%2848%29.png" alt="Elivara Arm Sculpt Compression Sleeves with premium packaging, 30-day money back guarantee, and free shipping, showing FlowMapping™ technology in action" className="w-full h-auto" data-id="element-174" />
                </div>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-175">
                  Here's something you should know: because of the specialized
                  FlowMapping™ technology and the lipedema-specific design,
                  Elivara can only produce limited quantities of these arm
                  sleeves.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-176">
                  And right now, they're offering first-time customers an
                  exclusive opportunity to save 40% off their order.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-177">
                  This isn't a permanent discount. It's specifically designed to
                  help women who've been suffering with lipedema finally access
                  a solution that actually works — without the premium price tag
                  that usually comes with specialized medical garments.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-178">
                  But here's the reality: these sell out. Fast.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-179">
                  When word gets out that there's finally compression that works
                  for lipedema AND feels comfortable enough to wear every day,
                  stock disappears in days. And when they're gone, you'll have
                  to wait for the next production run to get your hands on a
                  pair.
                </p>
                <p className="mb-3 sm:mb-4 font-semibold text-sm sm:text-base" data-id="element-180">
                  I don't want you to miss this opportunity.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-181">
                  If you've spent years feeling frustrated, ashamed, or stuck
                  with arms that won't respond no matter what you try — if
                  you've been told to "just lose weight" one more time by a
                  doctor who doesn't understand lipedema — if you're tired of
                  hiding in long sleeves and avoiding situations where your arms
                  might show...
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-182">
                  This is your chance to change that.
                </p>
              </div>
              {/* You Deserve Section */}
              <div className="mb-8 sm:mb-10" data-id="element-183">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-3 sm:mb-4 leading-tight" data-id="element-184">
                  You Deserve to Feel Normal Again
                </h2>
                <div className="mb-4 sm:mb-6 rounded-lg overflow-hidden" data-id="element-185">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fcFTP9s5La88PDr9GNhj1H/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_56_%CF%80.%CE%BC..png" alt="Woman confidently wearing a sleeveless dress with compression sleeves, enjoying freedom and comfort after using Elivara to manage her lipedema" className="w-full h-auto" data-id="element-186" />
                </div>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-187">
                  I want you to imagine something for a moment.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-188">
                  Imagine waking up and putting on a pair of arm sleeves that
                  actually make your arms feel better throughout the day instead
                  of worse.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-189">
                  Imagine that heavy, swollen feeling starting to lift. Imagine
                  less pain. Less tenderness. Less constant awareness of your
                  arms as a problem you have to manage.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-190">
                  Imagine wearing a tank top in the summer without a second
                  thought. Going to the beach. Traveling without fear of your
                  arms swelling unbearably. Exercising without the extra
                  discomfort that lipedema brings.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-191">
                  Imagine just... living. Normally. Without constantly thinking
                  about your arms.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-192">
                  That's what Elivara gave me. And that's what it can give you.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-193">
                  You're not alone. You're not broken. And you're not imagining
                  this condition.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-194">
                  Lipedema is real. It's valid. And now, there's finally a
                  solution that actually works.
                </p>
                <p className="mb-4 sm:mb-6 font-semibold text-sm sm:text-base" data-id="element-195">
                  Don't let another doctor tell you it's "just weight." Discover
                  Elivara today.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-196">
                  Don't wait until they're sold out again. Don't spend another
                  season hiding. Don't let another year go by feeling frustrated
                  and stuck.
                </p>
                <p className="mb-3 sm:mb-4 text-sm sm:text-base leading-relaxed" data-id="element-197">
                  Your arms deserve relief. And you deserve to feel confident
                  and comfortable in your own body again.
                </p>
              </div>
            </div>
          </main>
          {/* Right-side CTA - Always visible on desktop */}
          <aside className="hidden lg:block lg:w-80 lg:flex-shrink-0 mt-6" data-id="element-198">
            <div className="sticky top-6" data-id="element-199">
              <StickyCTA showNewImage={true} data-id="element-200" />
            </div>
          </aside>
        </div>
      </div>
      {/* Sticky CTA - Always visible at the bottom */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-3 sm:p-4 z-50 shadow-lg" data-id="element-201">
        <a href="https://tryelivara.com/pages/elivara-arm-sculpt-compression#te-featured-product" className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg shadow-md transition-all w-full uppercase tracking-wider text-center block text-sm sm:text-base" data-id="element-202">
          GET 40% OFF ELIVARA ARM SLEEVES NOW!
        </a>
      </div>
      {/* Special Offer Banner */}
      <div className="w-full bg-red-50 border-y border-red-200" data-id="element-203">
        <div className="container mx-auto px-4 py-4 sm:py-6" data-id="element-204">
          <div className="flex flex-col sm:flex-row items-center justify-center text-center gap-3 sm:gap-4" data-id="element-205">
            <div className="flex items-center" data-id="element-206">
              <AlertCircle className="text-red-500 mr-2 flex-shrink-0" size={20} data-id="element-207" />
              <p className="font-bold text-base sm:text-lg" data-id="element-208">SPECIAL OFFER:</p>
            </div>
            <p className="font-bold text-red-700 text-sm sm:text-base lg:text-lg px-0 sm:px-4" data-id="element-209">
              Get Elivara Arm Sculpt Compression Sleeves at 40% OFF + FREE
              Shipping for a Limited Time!
            </p>
            <a href="https://tryelivara.com/pages/elivara-arm-sculpt-compression#te-featured-product" className="bg-green-600 hover:bg-green-700 text-white font-bold py-2.5 sm:py-3 px-5 sm:px-6 rounded-lg text-sm sm:text-base whitespace-nowrap inline-block w-full sm:w-auto" data-id="element-210">
              CLAIM OFFER
            </a>
          </div>
        </div>
      </div>
      {/* Disclaimer */}
      <footer className="w-full bg-gray-100" data-id="element-211">
        <div className="container mx-auto px-4 py-4 sm:py-6 max-w-4xl" data-id="element-212">
          <div className="text-xs text-gray-500 pt-4 sm:pt-6 mb-6 sm:mb-8" data-id="element-213">
            <p className="mb-2 leading-relaxed" data-id="element-214">
              This is an advertisement and not an actual news article, blog, or
              consumer protection update. Individual results may vary.
            </p>
            <div className="flex flex-wrap gap-2 mb-2" data-id="element-215">
              <span data-id="element-216">About Us</span>
              <span data-id="element-217">|</span>
              <span data-id="element-218">Terms of Use</span>
              <span data-id="element-219">|</span>
              <span data-id="element-220">Privacy Policy</span>
            </div>
            <p className="mb-2 leading-relaxed" data-id="element-221">
              Trademarks utilized on our website belong to their respective
              owners and no implied or expressed endorsement of our website or
              services is intended. Through in-depth research and experienced
              editors we provide feedback about products and services. We are
              independently owned, and opinions expressed here are our own. This
              website is an independent professional comparison and review site
              supported by referral fees from the sites and products featured.
            </p>
            <p className="leading-relaxed" data-id="element-222">
              ©2025 Women's Health Insights. All Rights Reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>;
};